import * as React from "react";
import PropTypes from "prop-types";
import { DragSource } from "react-dnd";
import ItemTypes from "./item-types";

const style = {}; // optional style to be triggered on dragging here

const boxSource = {
  canDrag(props) {
    return props.type === "ORGANISATIONAL_UNIT";
  },
  beginDrag(props) {
    return {
      path: props.path,
      name: props.name,
      label: props.label,
      type: props.type,
    };
  },

  endDrag(props, monitor) {
    const item = monitor.getItem();
    const dropResult = monitor.getDropResult();
    if (props.onDrop && dropResult) props.onDrop(item.name, dropResult.id);
  },
};

export class DragWrapper extends React.Component {
  render() {
    const opacity = this.props.isDragging ? 0.4 : 1;

    return this.props.connectDragSource ? (
      this.props.connectDragSource(
        <div
          className={this.props.className}
          style={{ ...this.props.children.style, ...style, opacity }}
        >
          {this.props.children}
        </div>,
      )
    ) : (
      <div>Not connected DragWrapper</div>
    );
  }
}

DragWrapper.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
  connectDragSource: PropTypes.func,
  isDragging: PropTypes.boolean,
  type: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  path: PropTypes.string,
  label: PropTypes.string,
  onDrop: PropTypes.func,
};

export default DragSource(ItemTypes.BOX, boxSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))(DragWrapper);
